export default {
  en: {
    userList: 'User List',
    newUser: 'New User',
    keyword: 'Keyword',
    username: 'Username',
    fullName: 'Full Name',
    status: 'Status',
    action: 'Action',
    resetPassword: 'Reset Password',
    confirmRemoveUserTitle: 'Confirm',
    confirmRemoveUserMessage: 'Confirm to delete <strong>{username}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeUserSuccess: 'Delete user {username} success'
  },
  th: {
    userList: 'รายการผู้ใช้',
    newUser: 'สร้างผู้ใช้',
    keyword: 'คำที่ต้องการค้นหา',
    username: 'ชื่อผู้ใช้',
    fullName: 'ชื่อ - สกุล',
    status: 'สถานะ',
    action: 'Action',
    resetPassword: 'เปลี่ยนรหัสผ่าน',
    confirmRemoveUserTitle: 'ยืนยัน',
    confirmRemoveUserMessage: 'กรุณายืนยันการลบ <strong>{username}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeUserSuccess: 'ลบผู้ใช้ {username} สำเร็จ'
  }
}
